document.addEventListener('DOMContentLoaded', function () {
  const checkboxes = document.querySelectorAll('.product-swatcher.input-color__swatch');
  const quantityButtons = document.querySelectorAll('.qtybox .btnqty');
  const sliderThumbs = document.querySelectorAll('.product-single__thumbnails-item-slide');
  const nextButton = document.querySelector('.thumbnails-slider__next');
  const prevButton = document.querySelector('.thumbnails-slider__prev');
  const collapsibleTabs = document.querySelectorAll('.accordion__title');
  const productPrice = Number(document.querySelector("span[data-regular-price]").textContent.replace(/[^0-9.-]+/g, ""));

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener("click", () => changeDisplayingCollection(checkbox))
  });
  quantityButtons.forEach(button => {
    button.addEventListener("click", () => changeQuantity(button))
  });
  collapsibleTabs.forEach(tab => {
    tab.addEventListener("click", () => collapseTab(tab))
  });

  // CHANGE ITEM QUANTITY AND PRICE 
  function changeQuantity(button) {
    const submitPrice = document.querySelector("span[data-product-status]");
    const parentContainer = button.closest('.qtybox');
    const productQuantity = parentContainer.querySelector('.quantity-input');
    let qty = parseInt(productQuantity.value);
    if (Array.from(button.classList).includes('qtyplus')) {
      qty++;
    } else {
      if (qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty)) ? 1 : qty;
    productQuantity.value = qty;
    submitPrice.textContent = "- $" + qty * productPrice;
  }

  // CHANGE VARIANT IMAGES
  function changeDisplayingCollection(button) {
    let activeThumbs = 0;
    let activeDots = 0;
    let thumbWidth = 0
    const sliderTrack = document.querySelector(".product-single__main-slider-track");
    const dotsTrack = document.querySelector(".product-single__thumbnails-slider-track");
    const inputName = button ? button.value.split(' (')[0].toLowerCase().replace(' ', '_') : '';

    document.querySelectorAll('.product-color-label').forEach(label => {
      label.textContent = button.value;
    })
      
    sliderThumbs.forEach(thumb => {
      if (thumb.classList.toString().includes(inputName) || thumb.classList.toString().includes("all_variants")) {
        thumbWidth = thumb.style.width
        thumb.classList.remove('thumb-hide');
        if (thumb.classList.toString().includes("slick-dot")) {
          thumb.classList.remove('slick-active');
          if (activeDots == 0) {
            thumb.classList.add('slick-active');
            activeDots++
          }
        }
        activeThumbs++;
      } else {
        thumb.classList.add('thumb-hide');
        thumb.classList.remove('slick-active');
      }
    });
    sliderTrack.style.width = `${parseInt(thumbWidth, 10) * activeThumbs}px`;
    sliderTrack.style.transform = 'translateX(0)';
    dotsTrack.style.width = `${parseInt(sliderThumbs[0].style.width, 10) * activeThumbs}px`;
    dotsTrack.style.transform = 'translateX(0)';
    if (activeThumbs > 3) {
    $('.product-single__thumbnails-slider-track').slick('slickUnfilter'); 
    $('.product-single__thumbnails-slider-track').slick('slickFilter', ':not(.thumb-hide)');
    $('.product-single__thumbnails-slider-track').slick('refresh')
    }
  }

  const variant = document.querySelectorAll('.product-swatcher.input-color__swatch, .product-size.input-size');
  if (variant[0]) {
    $('.product-single__thumbnails-slider-track').slick({
        vertical: true,  
        verticalSwiping: true,
        arrows: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,  
        dots: false,
        responsive: [
          {
            breakpoint: 749,
            settings: "unslick"
          }
      ]
      })
    variant[0].click()
  } else {
    changeDisplayingCollection()    
  }

  // COLLAPSIBLE TAB
  function collapseTab(tab) {
    const container = tab.closest('.accordion');
    const plusIcon = container.querySelector('.icon-plus');
    const lessIcon = container.querySelector('.icon-less');
    const content = container.querySelector('.accordion__content');
    if($(".accordion__content").is(":visible")){
      $(plusIcon).show();
      $(lessIcon).hide();
      $(content).slideUp("fast");
    } else {
      $(plusIcon).hide();
      $(lessIcon).show();
      $(content).slideDown("fast");
    }
  }

  // OPEN MODAL
  $(".modal__link").click(function (button) {
    const content = $(button.currentTarget)[0].closest(".accordion__content").querySelector(".modal__content").innerHTML;
    $("#modal-container .modal-content").html(content);
    $("#modal-container").css({ zIndex: 100, opacity: 1 });
    $("#modal-container").show();
  })
  // CLOSE MODAL
  $("#modal-container .close").click(function () {
    $("#modal-container").css({ zIndex: 0, opacity: 0 });
    $("#modal-container").hide();
  })
  $(document).click(function (e) {
    if ($(e.target).is('#modal-container')) {
      $("#modal-container").css({ zIndex: 0, opacity: 0 });
      $("#modal-container").hide();
    }
  });

});
